import {
  Sparkles as EnhanceIcon,
  Scissors as ShortenIcon,
  Maximize2 as ExpandIcon,
  Briefcase as FormalIcon,
  MessageCircle as CasualIcon,
  SpellCheck as GrammarIcon,
  RefreshCw as RewriteIcon,
  Tags as KeywordsIcon,
  ListX as NoBulletsIcon,
  Pencil as CustomIcon,
} from "lucide-react";

export const ENHANCEMENT_OPTIONS = [
  {
    id: "improve",
    label: "Improve Overall",
    icon: EnhanceIcon,
    description: "General enhancement for clarity and impact",
  },
  {
    id: "shorten",
    label: "Shorten",
    icon: ShortenIcon,
    description: "Condense text while preserving meaning",
  },
  {
    id: "expand",
    label: "Expand",
    icon: ExpandIcon,
    description: "Add more detail and context",
  },
  {
    id: "formal",
    label: "Make Formal",
    icon: FormalIcon,
    description: "Convert to professional tone",
  },
  {
    id: "casual",
    label: "Make Casual",
    icon: CasualIcon,
    description: "Convert to friendly, conversational tone",
  },
  {
    id: "grammar",
    label: "Fix Grammar",
    icon: GrammarIcon,
    description: "Correct grammatical errors and typos",
  },
  {
    id: "rewrite",
    label: "Rewrite",
    icon: RewriteIcon,
    description: "Complete rewrite with same intent",
  },
  {
    id: "keywords",
    label: "Add Keywords",
    icon: KeywordsIcon,
    description: "Enhance with relevant keywords",
  },
  {
    id: "no-bullets",
    label: "Rewrite without bullet points",
    icon: NoBulletsIcon,
    description: "Turn bullet points into flowing prose paragraphs",
  },
  {
    id: "custom",
    label: "Custom Prompt",
    icon: CustomIcon,
    description: "User-defined transformation",
  },
];
